<template>
  <div class="category_container">
    <div class="category_wrapper">
      <div class="category_header_container">
        <div class="category_header_wrapper container">
          <div class="category_header_content">
            <div
              class="category_header_title"
            >A practical course on developing Android Apps with Java</div>
            <div class="rating_best_selling">
              <div class="best_selling_btn">
                <button type="button" class="yellow_button">BEST SELLING</button>
              </div>
              <star-rating
                :rating="3.8"
                :increment="0.01"
                :read-only="true"
                inactive-color="#777"
                active-color="#ffe234"
                :star-size="20"
              ></star-rating>
              <div class="ratings_number">
                (308 ratings)
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="category_design container">
        <div class="category_main_container">
          <div class="category_main_wrapper">
            <v-tabs v-model="tab">
              <v-tabs-slider></v-tabs-slider>

              <v-tab href="#tab-1">About</v-tab>

              <v-tab href="#tab-2">Instructor</v-tab>

              <v-tab href="#tab-3">Syllabus</v-tab>
            </v-tabs>

            <v-tabs-items v-model="tab">
              <v-tab-item :value="'tab-1'">
                <v-card flat>
                  <v-card-text>
                    <p>Based on the most popular open online course in the world, this course gives you easy access to the learning techniques used by experts in art, music, literature, math, science, sports, and many other disciplines. No matter what your current skill level, using these approaches can help you master new topics, change your thinking and improve your life.</p>
                    <p>Lorem Ipsum is simply dummy text of the printing and typesetting industry. Lorem Ipsum has been the industry's standard dummy text ever since the 1500s, when an unknown printer took a galley of type and scrambled it to make a type specimen book. It has survived not only five centuries, but also the leap into electronic typesetting, remaining essentially unchanged. It was popularised in the 1960s with the release of Letraset sheets containing Lorem Ipsum passages, and more recently with desktop publishing software like Aldus PageMaker including versions of Lorem Ipsum.</p>
                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary, making this the first true generator on the Internet. It uses a dictionary of over 200 Latin words, combined with a handful of model sentence structures, to generate Lorem Ipsum which looks reasonable. The generated Lorem Ipsum is therefore always free from repetition, injected humour, or non-characteristic words etc.</p>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :value="'tab-2'">
                <v-card flat>
                  <v-card-text>
                    <Instructor></Instructor>
                  </v-card-text>
                </v-card>
              </v-tab-item>
              <v-tab-item :value="'tab-3'">
                <v-card flat>
                  <v-card-text>
                    <!-- <div class="syllabus_title">
                      Courses
                    </div> -->
                    <Syllabus></Syllabus>
                  </v-card-text>
                </v-card>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
        <div class="category_sidebar_container">
          <div class="category_sidebar_wrapper">
            <div class="course_thumbnail">
              <div class="course_image">
                <img src="@/assets/images/mobile_app.png" />
                <div class="play_btn">
                  <v-icon>mdi-play</v-icon>
                </div>
                <div class="image_text">Preview this course</div>
              </div>
            </div>
            <div class="category_sidebar_content">
              <div class="sidebar_course_price">
                <div class="course_old_price">Rs.5000 </div>
                <div class="course_price">Rs.4000</div>
                <div class="course_off">20% off</div>
              </div>
              <div class="add_to_cart_wrapper">
                <button type="button" class="blue_button full_width big_btn">Add To Cart</button>
              </div>
              <div class="buy_now_wrapper">
                <button type="button" class="blue_outline_button full_width big_btn">Buy Now</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StarRating from 'vue-star-rating'
import Syllabus from './_partials/Syllabus'
import Instructor from './_partials/Instructor'
export default {
  data () {
    return {
      tab: null
    }
  },
  components: {
    StarRating,
    Syllabus,
    Instructor
  }
}
</script>

<style>
/* Caterory Header */
.category_container {
  position: relative;
}
.category_header_container {
  background: var(--color-dark-blue);
}
.category_header_content {
  padding-bottom: 4rem;
  margin-top: 7rem;
}
.category_header_title {
  font-size: 36px;
  max-width: 600px;
  line-height: 1.2;
  padding-bottom: 2rem;
  font-family: "Lora", serif;
  color: #fff;
}
.rating_best_selling{
  display: flex;
  align-items: center;
  color: #bbbbbb;
}
.vue-star-rating-rating-text{
  margin-top: 0 !important;
}

/* Fixed sidebar */
.category_design {
  display: grid;
  grid-template-columns: 1fr 350px;
  grid-gap: 3rem;
}
.category_sidebar_container {
  position: fixed;
  top: 20%;
  right: 10%;
}
.category_sidebar_wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #fff;
  box-shadow: 0 0 1px 1px rgba(20, 23, 28, 0.1),
    0 3px 1px 0 rgba(20, 23, 28, 0.1);
  border-radius: 4px;
  color: #505763;
  z-index: 999;
}
.course_image {
  position: relative;
}
.course_image img {
  width: 350px;
}
.play_btn {
  position: absolute;
  top: 30%;
  left: 40%;
}
.play_btn i {
  background-color: rgba(66, 66, 66, 0.78);
  padding: 15px;
  color: #fff !important;
  border-radius: 50%;
  font-size: 48px !important;
}
.category_sidebar_content {
  width: 100%;
  padding: 0 2rem 2rem 2rem;
}
.add_to_cart_wrapper {
  padding-bottom: 1rem;
}
.sidebar_course_price {
  display: flex;
  justify-content: center;
  align-items: baseline;
  padding: 1rem 0;
}
.course_old_price{
  font-size: 20px;
  padding-right: .5rem;
  text-decoration: line-through;
  color: #777;
}
.course_price {
  color: #505763;
  font-size: 28px;
  font-weight: bolder;
  padding-right: .5rem;
}
.image_text {
  position: absolute;
  bottom: 4%;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  color: #fff;
  font-size: 18px;
  font-weight: 600;
  padding-bottom: 5px;
  box-shadow: inset -1px -10px 20px 0px rgb(36, 50, 71);
  z-index: 1;
  width: 100%;
  height: 100%;
  text-shadow: 0 0 20px #000;
}

/* Mobile View */
@media screen and (max-width: 768px) {
  .category_design {
    display: flex;
    flex-direction: column-reverse;
    justify-content: center;
    align-items: center;
  }
  .category_sidebar_container {
    position: inherit !important;
    padding-bottom: 2rem;
  }
  .course_image img {
    width: 100%;
  }
  .category_header_title {
    font-size: 32px;
    text-align: center;
  }
  .category_header_content{
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
  }
  .rating_best_selling{
    flex-direction: column;
  }
}
</style>
